import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { useDataCatalogModel } from "../dataCatalogModel";
import { catalogService } from "../dataCatalogService";
import { ICatalogDetail } from "../dataCatalogTypes";

import { ColumnsType } from "antd/es/table";
const DataTable = () => {
    const { dataSource, selectedRowKeys, cataLogPage, selectedRow, loadData, setSelectedRowKeys, setSelectedRow } = useDataCatalogModel();

    useEffect(() => {
        loadData()
    }, [])
    const columns: ColumnsType<ICatalogDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '目录编码',
            dataIndex: 'code',
            width: 150,
        },
        {
            title: '目录名称',
            dataIndex: 'tableName',
            width: 150,
        },
        {
            title: '默认分支编码',
            dataIndex: 'defaultBranchCode',
        },
        {
            title: '远程查询',
            dataIndex: 'allowRemoteSelect',
            render: (text) => text ? "允许" : "不允许"

        },
        {
            title: '远程更新',
            dataIndex: 'allowRemoteUpdate',
            render: (text) => text ? "允许" : "不允许"

        },
        {
            title: '多分支',
            dataIndex: 'allowMultiBranch',
            render: (text) => text ? "允许" : "不允许"

        },
        {
            title: '状态',
            dataIndex: 'status',
            render: (text) => text ? "自动审核" : "人工审核"

        },
        {
            title: '备注',
            dataIndex: 'note',
        },
    ];
    const onRow = (record: ICatalogDetail) => {
        return {
            onClick: () => {
                if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                    setSelectedRowKeys([])
                    setSelectedRow({})
                } else {
                    setSelectedRowKeys([record.key as string])
                    setSelectedRow(record)
                }
            },
        }
    }
    const rowSelection = {
        onChange(selectedRowKeys: React.Key[], selectedRows: ICatalogDetail[]) {
            setSelectedRowKeys(selectedRowKeys)
        },
        selectedRowKeys
    }
    return (
        <Table
            columns={columns}
            dataSource={dataSource}
            rowSelection={{
                type: "radio",
                ...rowSelection
            }}
            onRow={onRow}
            pagination={{
                ...cataLogPage,
                position: ["bottomCenter"],
                showTotal: () => `共${cataLogPage.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
        />
    )
}
export default DataTable